import { Link } from "react-router-dom";
import { useDocsetManifest } from "../../context/DocsetContext";
import { docsetPath } from "../../utils/basePath";

export type Crumb = {
  title: string;
  pathSegments: string[];
};

type BreadcrumbsProps = {
  trail: Crumb[];
};

export function Breadcrumbs({ trail }: BreadcrumbsProps) {
  const manifest = useDocsetManifest();
  if (!trail || trail.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="doc-breadcrumbs my-3 text-xs text-slate-500">
      <ol className="m-0 flex list-none flex-wrap items-center gap-1 p-0">
        <li>
          <Link to={docsetPath(manifest.id)} className="hover:underline">
            {manifest.title}
          </Link>
        </li>
        {trail.map((c, idx) => {
          const href = docsetPath(manifest.id, c.pathSegments.join("/"));
          const isLast = idx === trail.length - 1;
          return (
            <li key={href} className="flex items-center gap-1">
              <span className="text-slate-400">›</span>
              {isLast ? (
                <span className="truncate text-slate-600">{c.title}</span>
              ) : (
                <Link to={href} className="truncate hover:underline">
                  {c.title}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
